<template>
    <div :class="mainClass">
        <finder-input v-if="isType('finder')" v-click-outside="cancelSearch"></finder-input>
        <post-box-list v-else-if="isType('box')"
                       :progress_lineal_color="progress_lineal_color"
                       :postType="postType"
                       :category="category"
                       :withNavigationBar="withNavigationBar"
                       :withNavigationPages="withNavigationPages"
                       :dataContent="dataContent"
                       :offSetScrollTo="offSetScrollTo"
        ></post-box-list>
        <awesome-slider v-else-if="isType('slider')"
                        :cat_type="cat_type"
                        :dataContent="dataContent"
        ></awesome-slider>
    </div>

</template>
<script>

    import {EventBus} from '../js/bus'
    import PostBoxList from './boxlist/PostBoxList'
    import FinderInput from './finder/FinderInput'
    import AwesomeSlider from './slider/AwesomeSlider'
    import vClickOutside from 'v-click-outside'

    export default {
        name: '',
        directives: {
            clickOutside: vClickOutside.directive
        },
        props: {
            type: {
                type: String,
                default: 'box'
            },
            progress_lineal_color: {
                type: String
            },
            postType: {
                type: String,
                default: 'cpt_sermon'
            },
            cat_type: {
                type: String,
                default: ''
            },
            category: {
                type: String,
                default: null
            },
            withNavigationBar: {
                type: Boolean,
                default: false
            },
            withNavigationPages: {
                type: Boolean,
                default: false
            },
            dataContent: {
                type: Object,
                default: () => {}
            },
            offSetScrollTo: {
                type: String,
                default: '0'
            }
        },
        components: {
            PostBoxList,
            FinderInput,
            AwesomeSlider
        },
        methods: {
            isType: function(tp) {
                var _tp = _.trim(tp)
                if ( _tp === '' )
                    _tp = 'box'
                return _tp === _.trim(this.type)
            },
            cancelSearch: function() {
                EventBus.$emit('cancelSearch')
            }
        },
        computed: {
            mainClass: function() {
                return 'gs-type-' + this.type
            },
        }
    }

</script>
<style lang="scss">
    .gs-type-box {
        .v-application--wrap {
            min-height:550px!important;
        }
    }
</style>
